import { createEntityAdapter } from '@reduxjs/toolkit';
import { IExtraComponent } from 'application/components/api/ExtraComponent';

export const extraComponentAdapter = createEntityAdapter<IExtraComponent, number>({
  selectId: (project) => project.extraComponentID,
});
